module.exports = "/_next/static/images/b0468133033514353c6121c31e6ab26d-two-people-looking-xs@3x.jpg.webp";